import { Component, Inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { SerialSearchComponent } from '../serial-search/serial-search.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectorDialogModel } from '../models/inspector-dialog.models';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: 'inspector-dialog',
    imports: [
        MatDialogModule,
        SerialSearchComponent,
        DropdownComponent,
        MatCheckboxModule,
        MatIcon
    ],
    templateUrl: './inspector-dialog.component.html',
    styleUrl: './inspector-dialog.component.scss'
})
export class InspectorDialogComponent {
  //dialog types
  // 1 = add new serial
  newSerialDialogTitle: string = this.qbuiltInspConstants.newSerialDialogTitle;
  newSerialInputTitle: string = this.qbuiltInspConstants.newSerialInputTitle;
  // 2 = photo attach
  photoAttachTitle: string = this.qbuiltInspConstants.attachPhotosTitle;
  optionalText: string = this.qbuiltInspConstants.optionalString;
  photoAttachMessage: string = this.qbuiltInspConstants.attachPhotosMessage;
  fileTypeMessage: string = this.qbuiltInspConstants.fileTypeMessage;
  addNewPhotoText: string = this.qbuiltInspConstants.addNewPhoto;
  uploadPhotoText: string = this.qbuiltInspConstants.uploadPhoto
  saveBtnText: string = this.qbuiltInspConstants.saveButtonText;
  // 3 = add observed defect
  odDefectTitle: string = this.qbuiltInspConstants.odDialogTitle;
  odDefectMessage: string = this.qbuiltInspConstants.odDialogMessage;
  // 4 = final sign off
  finalSignOffTitle: string = this.qbuiltInspConstants.finalSignOffTitle;
  finalSignOffMessage: string = this.qbuiltInspConstants.finalSignOffMessage;
  finalSignOffPlaceholder: string = this.qbuiltInspConstants.finalSignOffPlaceholder;
  //5 = designate to station
  designateTitle: string = this.qbuiltInspConstants.designateTitle;
  selectedStation: any;
  availableStations: any[] = [];

  //button Text 
  cancelButtonText: string = this.qbuiltInspConstants.cancelButtonText;
  startButtonText: string = this.qbuiltInspConstants.startmButtonText;
  confirmButtonText: string = this.qbuiltInspConstants.confirmButtonText;
  sendButtonText: string = this.qbuiltInspConstants.sendText;

  dialogType: number;
  inputValue: string = '';
  validSerial: boolean = false;

  observedDefectList: any[] = [];
  selectedDefectTask: any;

  isSignatureGenerated: boolean = false;
  userName: string = '';
  userId: number;
  signature: string = '';
  currentDateTime: string = '';

  photosAttached: boolean = false;
  attachedPhotos: any[] = [];

  //session storage keys
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;

  constructor(private qbuiltInspConstants: QBuiltInspectorConstants,
    public dialogRef: MatDialogRef<InspectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: InspectorDialogModel
  ) {
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null;
    dialogRef.disableClose = true
    this.dialogType = dialogData.dialogType;
    this.observedDefectList = dialogData.dataList || [];
    this.userName = dialogData.userName || '';
    this.userId = userData?.UserId || 0;
  }

  onSerialCheck(response: any) {
    if(response) {
      const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
      cqmsSessionItems.selectedSerial = response.serialNumber;
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
      this.inputValue = response;
      this.validSerial = true;
    }

  }

  onDefectSelected(defectTask: string) {
    if(defectTask) {
      this.selectedDefectTask = defectTask;
      //add to defect list or section list or both ?
      
    }
  }

  generateSignature(event: MatCheckboxChange): void {
    this.isSignatureGenerated = event.checked;
  
    if (event.checked) {
      this.signature = this.userName;
      this.currentDateTime = new Date().toLocaleString();
    } else {
      this.signature = ''; // Clear signature when unchecked
    }
  }

  onConfirm() {
    if(this.dialogType === 1) {
      this.dialogRef.close(this.inputValue);
      const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
      cqmsSessionItems.selectedSerial = '';
      sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    } else if(this.dialogType === 3) {
      this.dialogRef.close(this.selectedDefectTask);
    } else if(this.dialogType === 4) {
      this.dialogRef.close(this.userId);
    } else if(this.dialogType === 5) {
      this.dialogRef.close(this.selectedStation);
    }
  }

  takePhoto() {
    console.log('take photo clicked');
    //open camera
  }

  uploadPhoto() {
    console.log('upload photo clicked');
    //open file upload
  }

  //save Photo
  savePhotos(photos: any[]) {
    console.log('savephotos', photos);

  }

  //removes photo from list of possibled uploads
  removePhoto(index: number) {
    this.attachedPhotos.splice(index, 1);
  }

  onCancel() {
    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey) ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}') : {};
    cqmsSessionItems.selectedSerial = '';
    sessionStorage.setItem(this.cqmsSessionKey, JSON.stringify(cqmsSessionItems));
    this.dialogRef.close();
  }

  onStationSelected(station: any) {
    this.selectedStation = station;
  }

}